module.exports = __webpack_public_path__ + "static/img/bg_05.d0890f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_05.jpg
// module id = aCYP
// module chunks = 1